
























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {ProvinceStore} from "../../store";
import {Province} from "@/interfaces/entity/province";
import {CommonStatus} from "@/enums/status";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
    name: "ProvinceAction"
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true }) id!: number;
    CommonStatus = CommonStatus;

    get record() {
        return ProvinceStore.data[this.id];
    }

    async save(id: number) {
        const province: Province = ProvinceStore.data[id];
        if (!province) return;
        try {
            ProvinceStore.updateDataProvinceV21({ key: id, value: { ...province, isSaving: true } });
            await ProvinceStore.editProvinceV21(province);
            ProvinceStore.updateCachedDataProvinceV21({ key: id, value: province })
            this.$message.success("Sửa tỉnh thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Sửa tỉnh thất bại");
        } finally {
            ProvinceStore.updateDataProvinceV21({ key: id, value: { ...province, isSaving: false } });
            ProvinceStore.updateDataProvinceV21({ key: id, value: { ...province, editable: false } });
        }
    }

    edit(id: number) {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_EDIT_REGION)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        const province: any = { ...ProvinceStore.data[id] };
        if (!province) return;
        ProvinceStore.updateDataProvinceV21({ key: id, value: { ...province, isSaving: false } });
        ProvinceStore.updateDataProvinceV21({ key: id, value: { ...province, editable: true } });
    }

    async deleteProvince(id: number) {
        try {
            ProvinceStore.updateDataProvinceV21({ key: id, value: { ...ProvinceStore.data[id], isDeleting: true } });
            await ProvinceStore.deleteProvinceV21(id);
            this.$message.success("Xóa tỉnh thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa tỉnh thất bại");
        } finally {
            ProvinceStore.updateDataProvinceV21({ key: id, value: { ...ProvinceStore.data[id], isDeleting: false } });
        }
    }

    close(id: number) {
        let province = { ...ProvinceStore.data[id] };
        if (!province) return;
        province = { ...province, ...ProvinceStore.cachedData[id], ['editable']: false } as any;
        ProvinceStore.updateDataProvinceV21({ key: id, value: province })
    }
}
